// load polyfills
// enables IE10 - IE11
// import 'core-js/es5'
// import 'core-js/es6'
// import 'core-js/es7'
import 'core-js/shim'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/app'
import './styles/normalize.css'
import './styles/base.css'

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js